function View() {
	
}

View.prototype.pause = function() {

};

View.prototype.resume = function() {

};

